export default "__VITE_ASSET__DUwovEJL__"